export default "__VITE_ASSET__eO2_5i4I__"